import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "aria-label"]
const _hoisted_2 = { class: "deck-card__lineone" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "deck-card__linetwo" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["deck-card", { wide: $props.wide }]),
    href: $props.link,
    "aria-label": $options.deckCardAriaLabel,
    target: "_blank"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon-deck" }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, _toDisplayString($options.deckLocation), 1)
    ])
  ], 10, _hoisted_1))
}